import { render, staticRenderFns } from "./MarketingEmailCreateSend.vue?vue&type=template&id=1e8fe274&scoped=true"
import script from "./MarketingEmailCreateSend.vue?vue&type=script&lang=js"
export * from "./MarketingEmailCreateSend.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailCreateSend.vue?vue&type=style&index=0&id=1e8fe274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8fe274",
  null
  
)

export default component.exports